import { BaseLinkPreviewObject, addCloseButton } from './BaseLinkPreviewObject';
import { VideoLinkPreviewObject, addPlayButton } from './VideoLinkPreviewObject';

export default function addInteractiveElementsForCompose(lp: BaseLinkPreviewObject) {
    addCloseButton(lp);
    if (lp.hasOwnProperty('videoPlayer')) {
        addPlayButton(<VideoLinkPreviewObject>lp);
    }
}
